import * as t from  './actionTypes';
import * as api from './api';

export function loadTheme() {

  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.getTheme((success, theme, error) => {
      if (success) {
        dispatch({ type: t.THEME_LOAD_SUCCESS, theme: theme });
        dispatch({ type: t.UNSET_BUSY });
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
      }
    });
  }
}

export function editTheme(data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.editTheme(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.THEME_EDIT_SUCCESS, theme: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}
